module.exports = __webpack_public_path__ + "img/curriculum_des_1.99250c65.jpg";